import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {removePatient} from '../../store/reducers/patient';
import makeStyles from '@mui/styles/makeStyles';
import SearchIcon from '@mui/icons-material/Search';
import API from '../../app/api';
import _ from 'lodash';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import PatientInfo from '../../components/header/patientInfo';
import config from '../../app/config';
import {
    agylePref,
    cloneCurrentPref,
    patient as patientPreferences,
    saveAgylePreference,
    savePref,
} from '../../store/reducers/preferences';
import {Pagination, Tooltip} from '@mui/material';
import FiledWithHistory from '../../controls/agyle/filedWithHistory';
import useOpenState from '../../hooks/useOpenState';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Grid from '@mui/material/Grid';
import {ControlConsultantComponent, consultantDictionary} from '../../controls/agyle/clinitian';
import {ControlDiagnosisSimple} from '../../controls/agyle/diagnosis';
import {DischargeStatus, ReferredToService} from '../../controls/agyle/ecds';
import SvgIcon from '@mui/material/SvgIcon';
import UserMenu from '../../components/header/userMenu';
import SearchHint from '../../components/header/searchHint';
import {setAgyleHeaderContext, setSnackbar} from '../../store/reducers/globals';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import AgyleDialog from '../../components/modal/agyleDialog';
import {CopyIcon} from '../../components/icons/adminIcons';
import {hasPermission, isAdmin, Permissions, sendUserAudit} from '../../store/reducers/user';
import AgyleDatePicker from '../../components/ui/fields/agyleDatePicker';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import AgyleBlockSwitch from '../../components/ui/switch/agyleBlockSwitch';
import AdminPatientEyonix from '../admitPatientEyonix/adminPatientEyonix';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Typography from '@mui/material/Typography';
import AgyleLoadingSpinner from '../../components/other/agyleLoadingSpinner';
import { AUDIT_TYPES } from '../../util/auditUtil';

const useStyles = makeStyles((theme) => ({
    advancedSearch: {
        backgroundColor: theme.palette.background.paper,
        padding: 10
    },
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    search: {
        display: "inline-flex",
        justifyContent: "center",
        width: "100%",
        backgroundColor: theme.palette.mode === "light" ? "#e3e3e3" : "#434343",
        padding: 10,
        alignItems: "center"
    },
    linksIcon: {
        position: "absolute",
        right: 15,
        top: 5
    },
    searchIcon: {
        display: "grid",
        alignItems: "center"
    },
    dialogContentStyle: {
      //  backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    },
    fullName: {
        display: "inline-block",
        marginLeft: 10,
        fontWeight: 300,
    },
    familyName: {
        fontWeight: "bold",
        textTransform: "uppercase",
        marginRight: 5,
    },
    vvip: {
        color: "#e46060",
        border: "1px solid #e46060",
        padding: "3px",
        fontSize: "10px",
        marginRight: "6px",
        borderRadius: "16px",
        verticalAlign: "middle",
        display: "inline-block",
        height: "20px"
    },
    patientsTable: {
        width: "90%",
        marginLeft: "5%",
        marginTop: "20px"
    },
    searchButtons: {
        textAlign: 'center'
    },
    tableHeader: {
        backgroundColor: theme.palette.mode === 'light' ? '#e2e2e2' : '#363636',
        padding: "5px",
        marginBottom: "7px",
        color: "gray",
        fontSize: 12
    },
    tableRecord: {
        padding: "8px",
        marginBottom: "7px",
        backgroundColor: theme.palette.mode === 'light' ? '#cacaca' : '#434343',
        // backgroundColor: "rgb(67 67 67)",
        cursor: "pointer"
    },
    pagination: {
        width: "fit-content",
        margin: "auto"
    },
    fullNameHeader: {
        marginLeft: "10px"
    },
    sortedHeader: {
        cursor: "pointer"
    },
    buttonSelector: {
        borderRadius: 50,
        backgroundColor: theme.palette.grey["300"],
        color: "rgba(0, 0, 0, 0.87)",
        margin: "0 5px",
        fontSize: 10
    },
    headerText: {
        float: "left",
        marginTop: 4
    },
    menuIcon: {
        //position: "absolute",
       // top: 10
    },
    eyonixIcon: {
        position: "absolute",
        top: 10
    },
    divRow: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: "auto",
    },
}));

const AGE_RANGE_INITIAL = {
    min: 0,
    max: 130
}

function Patients() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();
    const agylePreference = useSelector(agylePref);

    const [patients, setPatients] = React.useState(null);
    const [patientsData, setPatientsData] = useState([]);
    const [totalPatients, setTotalCounter] = React.useState(0);
    const [openDetails, setOpenDetails] = useState(false);
    const [ageRange, setAgeRange] = useState(AGE_RANGE_INITIAL);

    const [patientsFiltered, setPatientsFiltered] = React.useState([]);
    const [patientsMode, setPatientsMode] = useState("all");

    const [loading, setLoading] = useState(false);

    // Search history

    const patientPreferencesObject = useSelector(patientPreferences);
    const historySearchAgyle = agylePreference?.searchHistoryEyonix? agylePreference?.searchHistory?.patientSearch.filter(element => element !== null) : [];
    const historySearchEyonix = patientPreferencesObject.searchHistoryEyonix? patientPreferencesObject.searchHistoryEyonix.filter(element => element !== null): [];
    const historySearch = process.env.BUILD_MODULE === "main"? historySearchEyonix: historySearchAgyle;

    const [pagesCount, setPagesCount] = React.useState(0);
    const [page, setPage] = React.useState(1);

    const [options, setOptions] = React.useState({
        resourceUri: "/patients",
        text: null,
        page: page,
        pageSize: config.modules.patients.pageSize,
        options: {},
    });
    const [searchOnlyNumbers, setSearchOnlyNumbers] = useState(false);
    const [searchOnlyNumberType, setSearchOnlyNumberType] = useState('all');

    const isEyonix = process.env.BUILD_MODULE === "main";

    // Advance search
    const [isAdvanceOpen, openAdvance, closeAdvance] = useOpenState(false, true);
    const [isNewPatientModalOpen, openNewPatientModal, closeNewPatientModal] = useOpenState(false, true);

    const [arrivalOrDischarge, setArrivalOrDischarge] = React.useState("arrival");
    const [attendanceId, setAttendanceId] = React.useState("");
    const [clinicians, setClinicians] = React.useState([]);
    const [referrals, setReferrals] = React.useState([]);
    const [diagnosis, setDiagnosis] = React.useState([]);
    const [dischargeStatus, setDischargeStatus] = React.useState(null);

    const [startDate, setStartDate] = React.useState(null);
    const [startTime, setStartTime] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [endTime, setEndTime] = React.useState(null);

    const [clearCtx, setClearCtx] = useState(false);

    const canViewSearch = dispatch(hasPermission(Permissions.AGYLE_CAN_FILTER_PATIENTS));
    const canViewPatientRecord = dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD));
    const canCreatePatient = dispatch(hasPermission(Permissions.CAN_CREATE_PATIENT));

    useEffect(() => {
        dispatch(removePatient());
        dispatch(cloneCurrentPref());
    }, []);

    useEffect(() => {
        if (canViewSearch && !clearCtx) dispatch(setAgyleHeaderContext(renderHeader()));
        else dispatch(setAgyleHeaderContext(null));
        return () => {
            // Clear header context
            dispatch(setAgyleHeaderContext(null));
        };
    }, [historySearch, clearCtx]);

    const filterPatientsByAge = (mode) => {
        const isPaedsPatient = (dob) => {
            return moment().diff(dob, "years") < 18;
        };

        switch (mode) {
            case "paeds":
                setPatientsFiltered(_.filter(patients, p => isPaedsPatient(p?.dob)));
                break;
            case "adults":
                setPatientsFiltered(_.filter(patients, p => !isPaedsPatient(p?.dob)));
                break;
            case "all":
            default:
                setPatientsFiltered(patients);
                break;
        }
    }

    const handleChangeAgeRange = (e, key) => {
        let onlyNumericValue = e.target.value.replace(/[^0-9]/g, '');
         if (onlyNumericValue.length > 1 && onlyNumericValue[0] === '0') {
             onlyNumericValue = onlyNumericValue.slice(1);
         }

        setAgeRange(prevState => ({
            ...prevState,
            [key]: onlyNumericValue ? onlyNumericValue : 0
        }))
    }

    const applyAgeRangeFilter = () => {
        if (ageRange.min === "" || ageRange.max === "") return;
        const min = ageRange.min ? ageRange.min : 0;
        const max = ageRange.max ? ageRange.max : 130;

        const patientsFilteredByAge = _.filter(patients, p => {
            const age = moment().diff(p?.dob, "years");
            return age >= min && age <= max;
        });

        setPatientsFiltered(patientsFilteredByAge);
    }

    const renderHeader = () => {
        return (
            <Grid container direction="row" justifyContent="center" alignItems="center">
                {searchOnlyNumbers &&
                    <AgyleBlockSwitch
                        onChange={setSearchOnlyNumberType}
                        value={searchOnlyNumberType}
                        customLabels={{
                            yes: t("All"),
                            no: t("Equals"),
                        }}
                        valueObject={{
                            true: "all",
                            false: "equals",
                        }}
                        style={{
                            marginRight: 5
                        }}
                    />
                }

                <SearchIcon fontSize="large"/>

                <div style={{width: "35%"}}>
                    <FiledWithHistory
                        placeholder={t("Search... You can search by patient name, hospital number or NHS number")}
                        handleSubmit={handleSubmit}
                        history={historySearch}
                        saveHistory={handleHistoryChange}
                    />
                </div>

                <SearchHint />

                <AgyleButton
                    onClick={openAdvance}
                    style={{marginRight: 20}}
                >
                    {t("Advanced options")}
                </AgyleButton>

                <AgyleBlockSwitch
                  onChange={setPatientsMode}
                  value={patientsMode}
                  customLabels={{
                      yes: t("PAEDS"),
                      no: t("ADULTS"),
                      empty: t("ALL")
                  }}
                  nullState
                  valueObject={{
                      true: "paeds",
                      false: "adults",
                      null: "all"
                  }}
                  style={{
                      marginLeft: 10
                  }}
                />

                <Grid item xs={4} sx={{ml: 2}} style={{display: 'flex', alignItems: 'center'}}>
                    <Typography variant="subtitle2" sx={{mr: 2}}>
                        {t("Age Range")}
                    </Typography>

                    <AgyleTextField
                        type="number"
                        value={ageRange.min}
                        min={0}
                        max={130}
                        textAlign="center"
                        onChange={(e) => handleChangeAgeRange(e, 'min')}
                        style={{width: 60}}
                        size="small"
                    />

                    <Typography variant="subtitle2" sx={{mx: 1.5}}>
                        {t("to")}
                    </Typography>

                    <AgyleTextField
                        type="number"
                        value={ageRange.max}
                        min={0}
                        max={130}
                        textAlign="center"
                        onChange={(e) => handleChangeAgeRange(e, 'max')}
                        style={{width: 60}}
                    />
                </Grid>
            </Grid>
        )
    }

    const setHoursAndMinutes = (date, time) => {
        return (moment(date).set({hour: time.hours(), minutes: time.minutes()}).toISOString())
    }

    const handleApplySearchOptions = () => {
        let start = startDate? startTime ? setHoursAndMinutes(startDate, startTime) : moment(startDate).toISOString() : "";
        let end = endDate? endTime ? setHoursAndMinutes(endDate, endTime) : moment(endDate).toISOString() : "";
        let referralCodes = [];
        _.forEach(referrals, v => referralCodes.push(v.snomedCode));
        let clinicianCodes = [];
        _.forEach(clinicians, v => clinicianCodes.push(v?.__code || v?.__id));
        let diagnosisCodes = [];
        _.forEach(diagnosis, v => diagnosisCodes.push(v.snomedCode));
        let dischargeStatusCode = [];

        if (dischargeStatus) {
            dischargeStatusCode.push(dischargeStatus?.snomedCode);
        }

        let body = {
            "wardIds": ["ED"],
            "arrivalFrom": arrivalOrDischarge === "arrival"? start : "",
            "arrivalTo": arrivalOrDischarge === "arrival"? end : "",
            "dischargeFrom": arrivalOrDischarge === "discharge"? start : "",
            "dischargeTo": arrivalOrDischarge === "discharge"? end : "",
            "referrals": referralCodes,
            "diagnosis": diagnosisCodes,
            "clerkingClinicians": clinicianCodes,
            "attendanceId": attendanceId,
        };

        if (!_.isEmpty(dischargeStatusCode)) {
            body["dischargeStatus"] = dischargeStatusCode;
        }

        setLoading(true);
        API.findPatients(body).then(res => {
            if (res.status === 200) {
                setPatients(_.filter(res.data.__data, d => !_.isNull(d)));
                setTotalCounter(res.data.__size);
                if(res.data.__pageCount) setPagesCount(res.data.__pageCount);
                window._scrollBarRef.updateScroll();
            }
            if (res.status === 204)
                setPatients([]);
            if (res.status !== 200 && res.status !== 204) {
                console.error("API.findPatients request status : " + res.status);
            }
        }).finally(() => setLoading(false))
        closeAdvance();
    };

    const handleSubmit = (value) => {
        if (value !== "") {
            searchPatients(value);
        }
    };

    const handleHistoryChange = (hist) => {
        if (hist) {
            if(process.env.BUILD_MODULE === "main") {
                let data = _.cloneDeep(patientPreferencesObject);
                data.searchHistoryEyonix = [...hist];

                dispatch(savePref(data, {showSnackbar: false}));
            } else {
                const obj = {
                    searchHistory: {
                        ...agylePreference.searchHistory,
                        patientSearch: [...hist]
                    }
                };
                dispatch(saveAgylePreference(obj));
            }
        }
    };

    useEffect(()=> {
        if(options.text !== null) {
            setLoading(true);
            setSearchOnlyNumberType('all');

            API.getSearchList(options).then(res => {
                if (res.status === 200) {
                    setPatients(_.filter(res.data.collection['__data'], p => !_.isNull(p)));
                    setTotalCounter(res.data.collection['__size']);
                    setPagesCount(res.data.collection['__pageCount']);
                    window._scrollBarRef.updateScroll();
                }
                if (res.status === 204)
                    setPatients([]);
                if (res.status !== 200 && res.status !== 204) {
                    console.debug("API.getPatientsList request status : " + res.status);
                }
            }).finally(() => setLoading(false));
        }

    },[options]);

    useEffect(() => {
        if (!_.isEmpty(patients) && !isEyonix) {
            const ids = patients.map(pt => pt?.__id);
            API.getPatientsAdditionalData(ids).then(data => {
                setPatientsData(data);
            });
        } else {
            setPatientsData([]);
        }
    }, [patients]);

    useEffect(() => {
        if (patients) applyAgeRangeFilter();
    }, [ageRange, patients]);

    useEffect(() => {
        if (searchOnlyNumbers) {
            if (searchOnlyNumberType === 'equals') {
                setPatientsFiltered(_.filter(patients, pt => {
                    return _.trim(pt?.hospitalNumber) === options?.text || _.trim(pt?.nhsNumber) === options?.text;
                }));
            } else {
                setPatientsFiltered(patients);
            }
        }
    }, [patients, searchOnlyNumbers, searchOnlyNumberType]);

    const searchPatients = (input) => {
        const searchText = input?.trim();
        if (!_.isEmpty(searchText)) {
            setSearchOnlyNumberType('all');
            setSearchOnlyNumbers(searchText.split(' ')?.length === 1);
            if (page > 1) setPage(1);
            setOptions((pr) => ({
                ...pr,
                text: searchText,
                page: 1,
            }));
        }
    };

    const patientDOB = (patient) => {
        if (patient) {
            const dob = moment(patient.dob);
            return dob.format(config.defaultDateFormat);
        }
        return "";
    };

    const patientYears = (patient) => {
        if (patient) {
            return moment().diff(moment(patient.dob), "years");
        }
        return "";
    };

    const handleCopyPtNumber = (number) => {
        if (!navigator.clipboard || !number) return;
        navigator.clipboard.writeText(number)
            .then(() => {
                dispatch(setSnackbar({
                    type: 'success',
                    message: 'The patient number has been copied to the clipboard.',
                }));
            });
    };

    const openPatient = (e, patient, isSearchLock) => {
        const disableOpenPatient = e.target.closest('.disabled-options') !== null;

        if (!disableOpenPatient && !openDetails) {
            switch(process.env.BUILD_MODULE) {
                case "agyle":{
                    if (isSearchLock) {
                        dispatch(setSnackbar({
                            type: 'warning',
                            message: 'The patient record is restricted.',
                        }));
                    } else {
                        dispatch(sendUserAudit({patient}, AUDIT_TYPES.OPEN_PATIENT_CONTEXT));
                        history.push('/patient-context/' + patient?.__id);
                    }
                    break;
                }
                case "main":{ ///EYONIX!!!!!
                    if(!canViewPatientRecord){
                        //snackbar about no permission to open patient record
                        dispatch(setSnackbar({
                            type: 'error',
                            message: 'User has no permission to open patient record.',
                        }));
                    } else {
                        // if(patient?.vip || false) {
                        //     if((canViewVIPPatientRecord || canViewSupervisedVIPPatientRecord)){
                        //         history.push('/patient/' + patient.hospitalNumber);
                        //     } else {
                        //         dispatch(setSnackbar({
                        //             type: 'error',
                        //             message: 'User has no permission to open VIP patient record.',
                        //         }));
                        //     }
                        // } else {
                        //    history.push('/patient/' + patient.hospitalNumber);
                        // }
                        history.push('/patient/' + patient.hospitalNumber);
                    }
                    break;
                }
                default: {
                    history.push('/patient/' + patient.hospitalNumber);
                }
            }
        }
    };

    const searchMenu = () => {
        let t;
        if (patients && patients.length > 0) {
            t = <div className={classes.patientsTable + ' search-menu-grid'}>
                <div>
                    Patients found: {(page-1)*config.modules.patients.pageSize } - { ((page-1)*config.modules.patients.pageSize) + patients.length} / {totalPatients}
                </div>
            </div>;
        }
        return t;
    };

    useEffect(() => {
      if (patients) {
        filterPatientsByAge(patientsMode);
      }
    }, [patientsMode, patients]);

    const renderPatientsList = () => {
        let patientsList = [];

        if (!_.isEmpty(patientsFiltered)) {
            patientsList.push(
                <div key="header" className={"patients-list-grid " + classes.tableHeader}>
                    <div className={classes.fullNameHeader + " " + classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Last Name")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("First Name")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Born")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Gender")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("Hospital Number")}</div>
                    </div>
                    <div className={classes.sortedHeader}>
                        <div className={classes.headerText}>{t("NHS Number")}</div>
                    </div>
                    <div className={classes.headerText}>{t("More Information")}</div>
                </div>
            );

            _.forEach(patientsFiltered, (patient, index) => {
                const isSearchLock = patient?.tags?.includes('searchLocked');

                patientsList.push(
                    <div
                        key={index}
                        onClick={(e) => openPatient(e, patient, isSearchLock)}
                        className={'patients-list-grid ' + classes.tableRecord}
                    >
                        <div className={classes.fullName}>
                            <span className={classes.familyName}>
                                {patient?.vip && <div className={classes.vvip}>VVIP</div>}
                                {patient.familyName}
                                {patient?.title && <span> ({patient.title})</span>}
                            </span>
                        </div>

                        <div>
                            {patient.firstName}
                        </div>

                        <div>
                            {patientDOB(patient)} ({patientYears(patient)} {t("years")})
                        </div>

                        <div>
                            {patient.gender}
                        </div>

                        <div className="disabled-options">
                            <Tooltip title={t("Copy Patient ID")}>
                                <IconButton
                                    onClick={handleCopyPtNumber.bind(this, patient?.hospitalNumber)}
                                    size="small"
                                >
                                    <CopyIcon/>
                                </IconButton>
                            </Tooltip>
                            {patient?.hospitalNumber}
                        </div>

                        <div className="disabled-options">
                            {patient?.nhsNumber &&
                                <Tooltip title={t("Copy Patient NHS No")}>
                                    <IconButton
                                        onClick={handleCopyPtNumber.bind(this, patient?.nhsNumber)}
                                        size="small"
                                    >
                                        <CopyIcon/>
                                    </IconButton>
                                </Tooltip>
                            }
                            {patient?.nhsNumber || 'Not provided'}
                        </div>

                        <div className="disabled-options">
                            <PatientInfo
                                patient={patient}
                                header={false}
                                handleOpenModals={setOpenDetails}
                                fromSearch
                                uploadHide={isEyonix}
                                eyonix={isEyonix}
                                additionalData={patientsData}
                                searchLock={isSearchLock}
                            />
                        </div>
                    </div>
                );
            });
        } else if (patients) {
            patientsList.push(
                <div key="nocontennt">
                    {t("Unfortunately we cannot find what you are looking for. Please adjust your search criteria")}
                </div>
            );
        }
        return patientsList;
    };

    const handlePageChange = (e, pageNumber) => {
        setPage(pageNumber);
        setOptions((pr)=>({
            ...pr,
            page: pageNumber
        }));
    };

    const [menuState, setMenuState] = React.useState(false);
    const openMenu = () => {
        setMenuState(true);
    };
    const closeMenu = () => {
        setMenuState(false);
    };

    if (!canViewSearch && process.env.BUILD_MODULE === "agyle") return <div className={classes.permission}>{t("You have no permissions to view this site")}</div>

    const haveHoldingPenAccess = () => {
        return dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD)) && (
            !config.modules.holdingPen.accessPermission ||
            dispatch(hasPermission(config.modules.holdingPen.accessPermission)) ||
            dispatch(isAdmin()))
    }
    return (
        <div>
            {process.env.BUILD_MODULE !== "agyle" &&
                <SwipeableDrawer
                    anchor={'left'}
                    open={menuState}
                    onClose={closeMenu}
                    onOpen={openMenu}
                >
                    <UserMenu open={menuState} />
                </SwipeableDrawer>
            }

            <div style={{position: "sticky", top: "0", zIndex: 2 }}>
                {process.env.BUILD_MODULE === "main" &&
                    <IconButton onClick={openMenu} classes={{ root: classes.eyonixIcon }} size="large">
                        <SvgIcon className="big_svg_icon" color="primary">
                            <path d="M21.493,2l-9.558,0.001C6.444,2.04,2,6.505,2,12.008c0,0.013,0,7.37,0,9.448C2.007,21.758,2.23,22,2.504,22h9.625
                        c5.393-0.065,9.752-4.392,9.871-9.77V2.557C22,2.248,21.772,2,21.493,2z M18.66,18.298c-0.004,0.201-0.151,0.363-0.335,0.363
                        h-6.411c-3.592-0.042-6.496-2.926-6.574-6.509V5.708c0-0.205,0.151-0.371,0.336-0.371h6.366c3.66,0.027,6.618,3.003,6.618,6.667
                        C18.66,12.012,18.66,16.915,18.66,18.298z"/>
                            <path d="M12.002,7.163c-2.673,0-4.838,2.168-4.838,4.836c0,2.672,2.165,4.838,4.838,4.838c2.669,0,4.836-2.166,4.834-4.838
                        C16.836,9.331,14.671,7.163,12.002,7.163z"/>
                        </SvgIcon>
                    </IconButton>
                }

                {process.env.BUILD_MODULE !== "agyle" &&
                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon/>
                        </div>

                        <div style={{width: "60%"}}>
                            <FiledWithHistory
                                placeholder={t(`Search... You can search by patient name, hospital number or ${isEyonix? "MRN" : "NHS"} number`)}
                                handleSubmit={handleSubmit}
                                history={historySearch}
                                saveHistory={handleHistoryChange}
                            />
                        </div>

                        <SearchHint/>
                        {isEyonix && canCreatePatient && <IconButton
                                edge="end"
                                disableRipple
                                aria-label="delete"
                                onClick={(e) => openNewPatientModal()}
                            >
                                <PersonAddIcon/>
                            </IconButton>
                        }

                        {isEyonix && haveHoldingPenAccess() && <AgyleButton variant="outlined" color="primary"
                                                                          style={{margin: "0 15px"}}
                                                                          onClick={() => {
                                                                              history.push('/holding');
                                                                          }}>
                            {t("Holding Pen")}
                        </AgyleButton>
                        }
                    </div>
                }
            </div>

            {loading && <AgyleLoadingSpinner/>}

            {!loading &&
                <>
                    <AgyleDialog
                        title={"Add Patient"}
                        open={isNewPatientModalOpen}
                        onClose={()=>{closeNewPatientModal()}}
                        width={"lg"}
                        contentStyle={classes.dialogContentStyle}
                        fullWidth
                        fullScreen
                        disableActions
                        closeButtonOnHeader
                    >
                        <AdminPatientEyonix closeModal={()=>{closeNewPatientModal()}}/>
                    </AgyleDialog>

                    {searchMenu()}

                    <div>
                        <div className={classes.patientsTable}>
                            {renderPatientsList()}
                        </div>
                        {patients && patients.length > 0 &&
                            <div className={classes.pagination}>
                                <Pagination count={pagesCount} page={page} showFirstButton showLastButton
                                            onChange={handlePageChange}/>
                            </div>
                        }
                    </div>
                </>
            }

            <AgyleDialog
                open={isAdvanceOpen}
                onClose={closeAdvance}
                width="md"
                fullWidth
                disableTitle
                onSave={handleApplySearchOptions}
                disableSubmit={(startDate && !startTime) || (endDate && !endTime)}
            >
                <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
                    <Grid item xs={12}>
                        <AgyleBlockSwitch
                          onChange={setArrivalOrDischarge}
                          value={arrivalOrDischarge}
                          customLabels={{
                              yes: t("Arrival"),
                              no: t("Discharge")
                          }}
                          valueObject={{
                              true: consultantDictionary.arrival,
                              false: consultantDictionary.discharge
                          }}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <AgyleDatePicker
                            type="date"
                            disabled={!arrivalOrDischarge}
                            inputFormat={config.defaultDateFormat}
                            label={t("Start Date")}
                            ampm={false}
                            value={startDate}
                            maxDateTime={moment()}
                            onChange={(newStartDate) => setStartDate(newStartDate)}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <AgyleDatePicker
                          type="time"
                          error={startDate && !startTime}
                          disabled={!arrivalOrDischarge}
                          inputFormat={config.defaultDateFormat}
                          label={t("Start Time")}
                          ampm={false}
                          value={startTime}
                          maxDateTime={moment()}
                          onChange={(newStartTime) => setStartTime(newStartTime)}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <AgyleDatePicker
                            type="date"
                            disabled={!arrivalOrDischarge}
                            inputFormat={config.defaultDateFormat}
                            label={t("End Date")}
                            ampm={false}
                            value={endDate}
                            onChange={(newEndDate) => setEndDate(newEndDate)}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <AgyleDatePicker
                            type="time"
                            disabled={!arrivalOrDischarge}
                            inputFormat={config.defaultDateFormat}
                            label={t("End Time")}
                            error={endDate && !endTime}
                            ampm={false}
                            value={endTime}
                            onChange={(newEndTime) => setEndTime(newEndTime)}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <ReferredToService
                            label={t("Referral")}
                            multiple
                            color="primary"
                            size="small"
                            customeDict
                            showAll
                            agyleRefresh
                            onChange={(_e, value) => setReferrals(value)}
                            value={referrals}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <ControlConsultantComponent
                            label={t("Clinician")}
                            showAll
                            agyleRefresh
                            allowedConsultants={arrivalOrDischarge}
                            size="small"
                            onChange={(value) => {
                                setClinicians(value);
                            }}
                            value={clinicians}
                            multiple
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AgyleTextField
                            shrink
                            size="small"
                            variant="outlined"
                            className={"custom-dt"}
                            placeholder={t("Search by...")}
                            label={t("Attendance")}
                            onChange={(e) => setAttendanceId(e.target.value)}
                            value={attendanceId}
                            style={{width: "100%", margin: 0}}
                       />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <ControlDiagnosisSimple
                            label={t("Diagnosis")}
                            showAll
                            agyleRefresh
                            size="small"
                            onChange={(value) => setDiagnosis(value)}
                            value={diagnosis}
                        />
                    </Grid>

                    {arrivalOrDischarge === 'discharge' &&
                      <Grid item xs={12}>
                        <DischargeStatus
                            label={t("Discharge Status")}
                            agyleRefresh
                            size="small"
                            showAll
                            onChange={(_e, val) => setDischargeStatus(val)}
                            value={dischargeStatus}
                        />
                    </Grid>
                    }
                </Grid>
            </AgyleDialog>
        </div>
    );
}

export default Patients;
